import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {useIsCompactQRTool} from '@Components/qr-code-generator/qr-code-generator-hooks';
import styles from './qr-select.module.scss';
import type {QRSelectOption, QRSelectProps} from './qr-select.types';

export function QRSelect({label, value, options, onValueChange}: QRSelectProps): ReactElement {
  const isCompact = useIsCompactQRTool();
  const renderOption = (option: QRSelectOption): ReactElement => {
    return (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    );
  };

  return (
    <label className={styles.qrSelect}>
      <Text val={label} size={isCompact ? TextSize.SM : TextSize.MD} bold />
      <span className={styles.qrSelectControlWrap}>
        <select
          className={styles.qrSelectControl}
          value={value}
          onChange={(event): void => {
            onValueChange(event.target.value);
          }}
        >
          {options.map(renderOption)}
        </select>
        <span className={styles.qrSelectCaret}>
          <Icon icon="icon-caret-down" size={IconSize.SIZE_ICON_16} />
        </span>
      </span>
    </label>
  );
}
